module.exports = __webpack_public_path__ + "static/panama-1-1b346f1e4d0737f902392b9a9b13f618.jpg";